import * as React from 'react';
import { Accordion, Card } from "react-bootstrap";
import './BeneficiaryDetail.css';

interface BeneficiaryDetailProps {
    beneficiary: {
        name: string;
        percentage: string;
        personalRelation: string;
        rsaIdNumber: string;
        dateOfBirth: string;
        email: string;
        phoneNumber: string;
    },
    emitHandleUpdate
}

export class BeneficiaryDetail extends React.Component<BeneficiaryDetailProps, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
        }
        
        this.handleUpdate = this.handleUpdate.bind(this);
    }
    
    handleUpdate() {
        this.props.emitHandleUpdate();
    }

    public render() {
        const beneficiary = {
            'Relationship to you': this.props.beneficiary.personalRelation,
            'Name and surname': this.props.beneficiary.name,
            'Date of birth': this.props.beneficiary.dateOfBirth,
            'ID no.': this.props.beneficiary.rsaIdNumber,
            'Email': this.props.beneficiary.email,
            'Phone no.': this.props.beneficiary.phoneNumber,
        };
        return <div className="beneficiary-detail">
            <Card>
                <Card.Title className="pb-0 pl-4 pt-4">
                    <h3 className="mb-0 update-beneficiaries__title">{ this.props.beneficiary.name }</h3>
                </Card.Title>
                <hr />
                <Card.Body className="beneficiary-detail__card-body">
                    <Accordion>
                        <Accordion.Toggle as={Card.Header} variant="text" eventKey="0">
                            Personal details
                        </Accordion.Toggle>
                        <Accordion.Collapse className="show beneficiary-detail__collapse" eventKey="0">
                          <>
                              <div className="row">
                                { Object.keys(beneficiary).map((key) =>
                                    <>
                                        <div className="col-6 beneficiary-detail__key">
                                            <p>{ key }</p>
                                        </div>
                                        <div className="col-6 beneficiary-detail__value">
                                            <p className="font-weight-bold">{ beneficiary[key] }</p>
                                        </div>
                                    </>
                                )}
                              </div>
                              <hr />
                              <div className="row justify-content-end">
                                  <div>
                                      <button onClick={this.handleUpdate} className="btn beneficiary-detail__update-button mr-3">
                                          <img className="arrow" src={"/my-policy/Images/Claims/Edit-pen.png"} />
                                          Update
                                      </button>
                                  </div>
                              </div>
                          </>
                        </Accordion.Collapse>
                    </Accordion>
                </Card.Body>
            </Card>
        </div>
    }

}